module.exports = __webpack_public_path__ + "img/terminal.130580cd.svg";